import { isBrowser } from '@mc/web-base-utils';

export const getPrefixCls = (type: string) => {
  return `notta-${type}`;
};

type Options = {
  format?: string;
  quality?: number;
  blur: [number?, number?];
};

export const processCdnUrl = (url: string, options: Options = { format: 'webp', quality: 100, blur: [0, 10] }) => {
  const { format, quality, blur } = options;

  return `${url}/m/filters:format(${format}):quality(${quality}):blur(${blur[0]})`;
};

export const blogPathArr = [
  '/blog/mp4-to-text',
  '/blog/best-voice-recorder',
  '/blog/mac-transcription',
  '/blog/10-best-google-chrome-extensions',
  '/blog/youtube-transcription',
];

export const getHotBlogParams = () => {
  if (typeof window === 'undefined') return null;
  const isHotBlog = blogPathArr.includes(window.location.pathname);
  return isHotBlog ? window.location.pathname.replace('/blog/', '') : null;
};

export const getABTestLoginSignUpUrl = (type: 'login' | 'signup') => {
  if (typeof window === 'undefined') return null;
  const origin = window.location.origin;

  let currentOrigin = 'https://app.notta.ai';
  if (origin.includes('dev')) {
    currentOrigin = 'https://dev-c0ee1fac76df136a.notta.ai';
  } else if (origin.includes('test')) {
    currentOrigin = 'https://test-app-12154205867b06a3.notta.ai';
  }

  return getHotBlogParams()
    ? `${currentOrigin}/${type}?language=ja&from=official&blog=${getHotBlogParams()}`
    : `${currentOrigin}/${type}?language=ja&from=official`;
};

// 加载脚本
export const loadScript = (src: string, id: string, className?: string) => {
  return new Promise<void>((resolve, reject) => {
    const isExitScript = document.getElementById(id);
    if (isExitScript) return;

    const script = document.createElement('script');
    script.id = id;
    script.classList.add(className);
    script.defer = true;
    script.src = src;
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
    document.body.appendChild(script);
  });
};

export const addLeadingZero = (number) => {
  return number > 0 && number < 10 ? `0${number}` : `${number}`;
};

export const randomIntFromInterval = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const getNumberFromRange = (min: number, max: number, n: number) => {
  if (n > max) {
    return max;
  } else if (n < min) {
    return min;
  } else {
    return n;
  }
};

export const loadFont = (fontFamily, fontStyle, fontWeight, url) => {
  const font = new FontFace(fontFamily, `url(${url})`, {
    style: fontStyle,
    weight: fontWeight,
  });

  font
    .load()
    .then((loadedFont) => {
      if (isBrowser()) {
        document.fonts?.add(loadedFont);
      }
    })
    .catch(() => {});
};
